import React from "react"
import { useTranslation } from "react-i18next"
import * as Components from "../../components/components"
import { getBT_158_1Options, getISO6523_BT157Options, getLaenderCodes } from "../../constants"
import { Position } from "../../models/position"

interface PositionSonstigeViewProps {
    path: string
    position: Position
    onChange: (propertyname: string) => (v: any) => void
}

export function PositionSonstigeView({ position, onChange }: PositionSonstigeViewProps) {
    const laenderOptions = getLaenderCodes()
    const { t } = useTranslation()
    const bt_158_1 = getBT_158_1Options()
    const ISO6523_BT157 = getISO6523_BT157Options()

    return (
        <Components.Collapsible title={t("rechnung.positionen.sonstigePositionsdaten.title")} collapsed={true}>
            <Components.FormGroup label={t("rechnung.positionen.positionstext.label")}>
                <Components.TextEdit
                    placeholder={t("rechnung.positionen.positionstext.placeholder")}
                    onChange={onChange("positionstext")}
                    value={position.positionstext}
                />
            </Components.FormGroup>

            <Components.FormGroup label={t("rechnung.positionen.positionskennung.label")}>
                <Components.TextEdit
                    placeholder={t("rechnung.positionen.positionskennung.placeholder")}
                    onChange={onChange("positionskennung")}
                    value={position.positionskennung}
                />
            </Components.FormGroup>

            <Components.FormGroup label={t("rechnung.positionen.artikelnummerKaeufer.label")}>
                <Components.TextEdit
                    placeholder={t("rechnung.positionen.artikelnummerKaeufer.placeholder")}
                    onChange={onChange("artikelnummerKaeufer")}
                    value={position.artikelnummerKaeufer}
                />
            </Components.FormGroup>
            <Components.FormGroup label={t("rechnung.positionen.artikelnummer.label")}>
                <Components.TextEdit
                    placeholder={t("rechnung.positionen.artikelnummer.placeholder")}
                    onChange={onChange("artikelnummer")}
                    value={position.artikelnummer}
                />
            </Components.FormGroup>
            <Components.FormGroup label={t("rechnung.positionen.artikelnummerCode.label")}>
                <Components.MultiSelect
                    placeholder={t("rechnung.positionen.artikelnummerCode.placeholder")}
                    onChange={onChange("artikelnummerCode")}
                    value={ISO6523_BT157.find((o) => o.value === position.artikelnummerCode)}
                    options={ISO6523_BT157}
                />
            </Components.FormGroup>
            <Components.FormGroup label={t("rechnung.positionen.artikelklassifizierung.label")}>
                <Components.TextEdit
                    placeholder={t("rechnung.positionen.artikelklassifizierung.placeholder")}
                    onChange={onChange("artikelklassifizierung")}
                    value={position.artikelklassifizierung}
                />
            </Components.FormGroup>
            <Components.FormGroup label={t("rechnung.positionen.artikelklassifizierungSchema.label")}>
                <Components.MultiSelect
                    placeholder={t("rechnung.positionen.artikelklassifizierungSchema.placeholder")}
                    onChange={onChange("artikelklassifizierungSchema")}
                    value={bt_158_1.find((o) => o.value === position.artikelklassifizierungSchema)}
                    options={bt_158_1}
                />
            </Components.FormGroup>
            <Components.FormGroup label={t("rechnung.positionen.artikelklassifizierungSchemaVersion.label")}>
                <Components.TextEdit
                    placeholder={t("rechnung.positionen.artikelklassifizierungSchemaVersion.placeholder")}
                    onChange={onChange("artikelklassifizierungSchemaVersion")}
                    value={position.artikelklassifizierungSchemaVersion}
                />
            </Components.FormGroup>
            <Components.FormGroup label={t("rechnung.positionen.artikelherkunft.label")}>
                <Components.MultiSelect
                    placeholder={t("rechnung.positionen.artikelherkunft.placeholder")}
                    onChange={onChange("artikelherkunft")}
                    value={laenderOptions.find((o) => o.value === position.artikelherkunft)}
                    options={laenderOptions}
                />
            </Components.FormGroup>
            <Components.FormGroup label={t("rechnung.positionen.kontierungshinweis.label")}>
                <Components.TextEdit
                    placeholder={t("rechnung.positionen.kontierungshinweis.placeholder")}
                    onChange={onChange("kontierungshinweis")}
                    value={position.kontierungshinweis}
                />
            </Components.FormGroup>
        </Components.Collapsible>
    )
}
